import apiClient from './config'

// 消息相关API
export const messageApi = {
  /**
   * 保存留言（医生给患者添加留言）
   * @param {Object} data - 留言数据
   * @param {string} data.content - 留言内容（≤500字）
   * @param {number} data.targetId - 接收者ID（患者ID）
   * @param {string} data.targetName - 接收者姓名
   */
  saveMessage(data) {
    return apiClient.post('/messages/save', data)
  },

  /**
   * 查询留言列表
   * @param {number} [patientId] - 可选，患者ID。如果传入则查询指定患者的留言，否则查询所有留言
   * @returns {Promise} 返回留言列表
   */
  getMessageList(patientId) {
    const params = patientId ? { patientId } : {}
    return apiClient.get('/messages/list', { params })
  }
}

